import 'css-chunksrc/client/scenes/accessRestrictionsEdition/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_4cx6x_1",
  "input": "_input_4cx6x_5",
  "openedInput": "_openedInput_4cx6x_22",
  "iconOpen": "_iconOpen_4cx6x_28",
  "iconClose": "_iconClose_4cx6x_39",
  "listRoot": "_listRoot_4cx6x_47",
  "list": "_list_4cx6x_47",
  "role": "_role_4cx6x_1",
  "textHidden": "_textHidden_4cx6x_71",
  "selectedRole": "_selectedRole_4cx6x_76",
  "selectedRoleIcon": "_selectedRoleIcon_4cx6x_80",
  "selectedRoleTitle": "_selectedRoleTitle_4cx6x_86",
  "roleDescription": "_roleDescription_4cx6x_93",
  "selectedRoles": "_selectedRoles_4cx6x_98"
};